import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons";
import Modal from '../../components/common/Modal/Modal';
import "./RegionSpecificPromoModal.scss";

const LOCAL_STORAGE_KEY = 'spanish_promo_last_seen_timestamp';
const COOLDOWN_HOURS = 6;
const YOUTUBE_VIDEO_ID = 'AYexZCqQAqQ';


export const RegionSpecificPromoModal: React.FC = () => {
    const [show, showSet] = useState(false);

    useEffect(() => {
        // Check if user has seen the promo recently
        const lastSeen = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (lastSeen) {
            const lastSeenTime = parseInt(lastSeen, 10);
            const hoursSinceSeen = (Date.now() - lastSeenTime) / (1000 * 60 * 60);
            if (hoursSinceSeen < COOLDOWN_HOURS) {
                return;
            }
        }

        // Check for Spanish language
        // navigator.language returns e.g., 'es-ES', 'es', 'en-US'
        const isSpanish = navigator.language.toLowerCase().startsWith('es');

        if (isSpanish) {
            showSet(true);
        }
    }, []);

    const handleClose = () => {
        showSet(false);
        localStorage.setItem(LOCAL_STORAGE_KEY, Date.now().toString());
    };

    return (
        <Modal
            show={show}
            handleClose={handleClose}
            title="¡Descubre ArtCraft!"
            subtitle="La herramienta definitiva de IA para imágenes y vídeo."
            large={true}
            content={() => (
                <div className="d-flex flex-column gap-3">
                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                        <iframe
                            src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=0`}
                            title="Presentando ArtCraft"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%'
                            }}
                        />
                    </div>
                </div>
            )}
            footerContent={
                <div className="w-100 d-flex justify-content-center align-items-center">
                    <a 
                        href="https://getartcraft.com/?utm_source=fakeyou.com&utm_medium=spanish_modal" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn d-flex align-items-center gap-2 text-nowrap artcraft-promo-modal-btn"
                        style={{ fontWeight: 600, }}
                    >
                        Prueba ArtCraft Gratis
                        <FontAwesomeIcon icon={faExternalLinkAlt} size="sm" />
                    </a>
                </div>
            }
            showButtons={false}
        />
    );
};
